/**
 * Purpose:
 * - Bind a public URL locale to the active Pragnu i18n language.
 *
 * Responsibility:
 * - Synchronize the locale from the public route before rendering its page.
 * - Keep public locale routing isolated from tenant/platform routes.
 *
 * Affects:
 * - Locale-prefixed public pages only.
 */

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { normalizeLanguage } from "../i18n/i18n.js";

export default function PublicLocaleRoute({ locale }) {
  const { i18n } = useTranslation();

  const currentLanguage = normalizeLanguage(
    i18n.resolvedLanguage || i18n.language,
  );

  useEffect(() => {
    if (currentLanguage === locale) return;

    void i18n.changeLanguage(locale);
  }, [currentLanguage, i18n, locale]);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  if (currentLanguage !== locale) {
    return null;
  }

  return <Outlet />;
}
